module.exports = __webpack_public_path__ + "stylesheets/m-wave-typography_ec4c1dc356d024bccb9509b4fbe756f7.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/mobile/wave/m-wave-typography.less
// module id = BTge
// module chunks = 151